import { loadExperienceTypes } from "@components/services/resources.js";

export default {
    data() {
        return {
            loadExperienceTypes,
            experienceTypes: [],
        };
    },
    created() {
        this.fetchExperienceTypes();
    },
    methods: {
        fetchExperienceTypes() {
            return loadExperienceTypes({}).then((response) => {
                this.experienceTypes = response.data
            })
        },
        filterGridsByJobType(grids) {
            if (!grids || grids.length === 0) {
                return [];
            }

            const jobExperienceType = this.experienceTypes.find(et => et.slug == 'PRES')

            return grids.filter(g => g.pivot.experience_type_id === jobExperienceType.id);
        },
        filterGridsByOccupationType(grids) {
            if (!grids || grids.length === 0) {
                return [];
            }

            const occupationExperienceType = this.experienceTypes.find(et => et.slug == 'ME')

            return grids.filter(g => g.pivot.experience_type_id === occupationExperienceType.id);
        },
    }

}